export default __webpack_public_path__ + "static/media/ReactRedux.de5a6736.jfif";